// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GuIZ","questions":"styles_questions__1FJit","footer":"styles_footer__2jbS9"};